module.exports = __webpack_public_path__ + "static/img/google.3f8a99e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/component/footer/google.png
// module id = dGny
// module chunks = 30